import { http } from '../../../../api/http';
import type { Cobranza, CobranzaCreateRequest, EstadoCuentaCliente } from '../types/cobranza.types';

export class CobranzaService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/cobranza',
  };

  public static async getAll(): Promise<Cobranza[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching cobranzas:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<Cobranza> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching cobranza:', error);
      throw error;
    }
  }

  public static async save(data: CobranzaCreateRequest): Promise<Cobranza> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving cobranza:', error);
      throw error;
    }
  }

  public static async update(id: number, data: CobranzaCreateRequest): Promise<Cobranza> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating cobranza:', error);
      throw error;
    }
  }

  public static async delete(id: number): Promise<boolean> {
    try {
      await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting cobranza:', error);
      throw error;
    }
  }

  public static async getEstadoCuenta(idCliente: number): Promise<EstadoCuentaCliente> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/estado-cuenta/${idCliente}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching estado cuenta:', error);
      throw error;
    }
  }
}
